export const EyeOffIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 24"
      width="1em"
      height="1em"
      fill="none"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <g clipPath="url(#clip0_4261_49451)">
          <path
            d="M18.44 17.94C16.7306 19.243 14.6491 19.9649 12.5 20C5.5 20 1.5 12 1.5 12C2.74389 9.68192 4.46914 7.65663 6.56 6.06003M10.4 4.24002C11.0883 4.0789 11.7931 3.99836 12.5 4.00003C19.5 4.00003 23.5 12 23.5 12C22.893 13.1356 22.1691 14.2048 21.34 15.19M14.62 14.12C14.3454 14.4148 14.0141 14.6512 13.6462 14.8151C13.2782 14.9791 12.8809 15.0673 12.4781 15.0744C12.0753 15.0815 11.6752 15.0074 11.3016 14.8565C10.9281 14.7056 10.5887 14.4811 10.3038 14.1962C10.019 13.9113 9.79439 13.572 9.64351 13.1984C9.49262 12.8249 9.41853 12.4247 9.42563 12.0219C9.43274 11.6191 9.52091 11.2219 9.68488 10.8539C9.84884 10.4859 10.0853 10.1547 10.38 9.88003"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.5 1L23.5 23"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4261_49451">
            <rect width="24" height="24" fill="none" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    </svg>
  );
};
